<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="1200" height="800" :show-footer="false" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="万里牛精斗云对账">
			<template #default>
				<input ref="decodeaddressuploadfile" style="display: none;" type="file" @change="importMethod">
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="primary" @click="importdata">导入</vxe-button>
						<vxe-button @click="exportdata">导出</vxe-button>
						<vxe-button status="danger" @click="analysis" :loading="loading">对账</vxe-button>
					</template>
				</vxe-toolbar>
				<el-divider content-position="center">应付汇总表</el-divider>
				<vxe-grid v-bind="gridOptions" v-if="gridOptions" ref="decodeaddresstable">
				</vxe-grid>
				<exportTable :ref="exportRef" listType="report" />
			</template>

		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import exportTable from '@_system/components/export/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				model: true,
				tableList: [],
				orderinfo: [],
				columns: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				primarykey: '供应商编码',
				additionalkey: ['精斗云编码','供应商名称','期初应付款','预付款余额','当前应付款','精斗云预付款余额','精斗云当前应付款','预付款差额','应付款差额'],
				buff: true,
				isfinish: true,
				totalNum: 0,
				progress: 0
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			getOption() {
				return {
					border: true,
					size: 'mini',
					data: this.tabledata,
					columns: this.columns,
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showOverflow: true,
					height: '80%',
					sortConfig: {
						remote: false
					}
				}
			},
			exportdata() {
				let columns = JSON.parse(JSON.stringify(this.columns))
				columns.forEach((item) => {
					item.visible = true
				})
				let obj = {
					data: this.tabledata,
					columns: columns
				}
				this.$refs[this.exportRef].exportData(obj)
			},
			importdata() {
				this.$refs.decodeaddressuploadfile.click()
			},
			importMethod(e) {
				let file = e.target.files[0]
				let reader = new FileReader();
				reader.onload = (e) => {
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary'
					})
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet, {
						defval: null,
						raw: false
					})
					jsonData = jsonData.map(row => {
						let newRow = {};
						for (let key in row) {
							let value = String(row[key]);
							if(value && value!='null'){
								newRow[key] = value.replace(/\t/g, '');
							}
							// 去除制表符
							
						}
						return newRow;
					});
					console.log(jsonData)
					let suppliercodes = []
					if (jsonData.length != 0) {
						jsonData.forEach((item) => {
							suppliercodes.push(item['供应商编码'])
							this.additionalkey.forEach((_item) => {
								item[_item] = item[_item] ? item[_item] : null
							})
						})
						console.log(suppliercodes)
						this.$api.supplier.list({code:suppliercodes.join(',')}).then((supplier)=>{
		
							jsonData.forEach((item)=>{
								let obj = supplier.list.find((res)=>{
									return res.code == item['供应商编码']
								})
								if(obj){
									item['精斗云编码'] = obj.jdycode
								}
							})
							
							let columns = []
							for (let i in jsonData[0]) {
								let obj = {
									field: i,
									title: i,
									visible: false
								}
								if (i == this.primarykey || this.additionalkey.findIndex((col) => {
										return col == i
									}) !== -1) {
									obj.visible = true
								}
								columns.push(obj)
							}							
							this.columns = columns
							this.tabledata = jsonData
							this.gridOptions = this.getOption()
							this.importLoading = false
							
	
							
						})
					} else {
						this.importLoading = false
						this.$message.error('暂无数据')
					}
				}
				
				reader.readAsBinaryString(file)


			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
						
			analysis() {
				let handle = this.$loading()
				this.$api.tool.balanceItemReport().then((res) => {
					let needpay = res['needpay']
					let prepay = res['prepay']
					this.tabledata.forEach((item)=>{
						this.$loadingclose(handle)
						if(item['精斗云编码']){
							item['精斗云预付款余额'] = 0
							item['精斗云当前应付款'] = 0
							let _prepay = prepay.find((preitem)=>{
								return preitem.itemNumber == item['精斗云编码']
							})
							let _needpay = needpay.find((needitem)=>{
								return needitem.itemNumber == item['精斗云编码']
							})
							if(_prepay){
								item['精斗云预付款余额'] = _prepay.amount
							}
							if(_needpay){
								item['精斗云当前应付款'] = _needpay.amount
							}
							item['预付款差额'] = (parseFloat(item['预付款余额']) - parseFloat(item['精斗云预付款余额'])).toFixed(2)
							item['应付款差额'] = (parseFloat(item['当前应付款']) - parseFloat(item['精斗云当前应付款'])).toFixed(2)
							
							
							
						}
					})
				}, () => {
					this.$loadingclose(handle)
				})
			},


		},
		components: {
			exportTable
		}
	}
</script>